module.exports = __webpack_public_path__ + "4.e8b134ea.jpg";